import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataCacheService } from "@app/services/caching/data-cache.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ResellerUserGroupMappingService {
    private cacheName: string = "resellerUserGroupMappingsCache";
    constructor(private readonly http: HttpClient,
        private readonly dataCacheService: DataCacheService) { }

    getMappings(queryOptions: IResellerUserGroupMappingQueryOptions = {}): Observable<IResellerUserGroupMapping[]> {
        const options = { params: queryOptions as HttpParams }

       return this.http.get<IResellerUserGroupMapping[]>(`/api/foundation/resellermapping/usergroup`, options);
    }

    getMappingsFromDb(queryOptions: IResellerUserGroupMappingQueryOptions = {}): Observable<IResellerUserGroupMapping[]> {
        const options = { params: queryOptions as HttpParams }

        return this.http.get<IResellerUserGroupMapping[]>(`/api/foundation/resellermapping/usergroup`, options);
    }

    updateMappings(resellerIds: number[], userGroupId: number): Observable<IResellerUserGroupMapping[]> {
        return this.http.post<IResellerUserGroupMapping[]>(`/api/foundation/resellermapping/usergroup/update/${userGroupId}`, resellerIds);
    }
}

export interface IResellerUserGroupMappingQueryOptions {
    Id?: number;
    UserGroupId?: number;
    ResellerId?: number;
    IsActive?: boolean;
}

export interface IResellerUserGroupMapping {
    Id: number;
    UserGroupId: number;
    ResellerId: number;
    StartTime: Date;
    EndTime?: Date;
}

